import type { TFunction } from '@multaqa/i18n'
import { z } from 'zod'

/**
 * A factory, not a constant, because `FormMessage` renders `error.message`
 * verbatim. A translation key placed there reaches the user as the key itself.
 */
export function supplierFormSchema(t: TFunction) {
  return z.object({
    code: z.string().min(1, t('supplier.validation.codeRequired')),
    // Both names: the supplier appears on English and Arabic documents.
    name: z.object({
      en: z.string().trim().min(1, t('supplier.validation.nameEnRequired')),
      ar: z.string().trim().min(1, t('supplier.validation.nameArRequired')),
    }),
    address: z.object({ en: z.string(), ar: z.string() }),
    country: z.string().min(1, t('supplier.validation.countryRequired')),
    tax_identifier: z.string().optional().nullable(),
    payment_terms_id: z.string().nullable(),
    default_currency: z.string().min(3).max(3),
    department_id: z.string().optional().nullable(),
    is_intercompany: z.boolean(),
    target_company_id: z.string().optional().nullable(),
    is_active: z.boolean(),
  })
}

export type SupplierFormValues = z.infer<ReturnType<typeof supplierFormSchema>>

export function supplierContactFormSchema(t: TFunction) {
  return z.object({
    name: z.string().min(1, t('supplier.validation.contactNameRequired')),
    role: z.string().optional().nullable(),
    phone: z.string().optional().nullable(),
    email: z
      .union([z.string().email(t('supplier.validation.emailInvalid')), z.string().length(0)])
      .optional()
      .nullable(),
    is_primary: z.boolean(),
  })
}

export type SupplierContactFormValues = z.infer<ReturnType<typeof supplierContactFormSchema>>
